import styled from "styled-components";

export const StyledDeleteModalHeader = styled.div`
    margin-bottom: 36px;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const StyledReplaceModalText = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const StyledTermsDetails = styled.div`
    overflow: auto;
    padding: 16px 20px 16px 20px;
`;
export const StyledTermsModalText = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const StyledTermsModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 20px;
    padding-left: 20px;
`;

export const CUSTOM_DELETE_STYLES = {
    content: { padding: "20px 20px 8px 20px", width: "460px", height: "214px" },
};

export const CUSTOM_DISCONNECT_STYLES = {
    content: { padding: "20px", width: "460px", height: "250px" },
};

export const CUSTOM_REPLACE_STYLES = {
    content: { padding: "20px 24px 16px 24px", width: "460px", height: "224px" },
};

export const CUSTOM_TERMS_STYLES = {
    content: { padding: "20px 0 20px 0", width: "550px" },
};

export const CUSTOM_TERMS_CONFIRM_STYLES = {
    marginRight: 16,
};

export const CUSTOM_TERMS_DETAILS_STYLES = {
    marginBottom: 16,
};
